<template>
  <div>
    <hi-cell title="合同编号：" :value="headInfo.contractCode"></hi-cell>
    <hi-cell title="合同名称：" :value="headInfo.contractTitle"></hi-cell>
    <hi-cell title="合同所属组织：" :value="headInfo.corpFullName"></hi-cell>
    <hi-cell title="申请人：" :value="headInfo.crtUserName"></hi-cell>
    <hi-cell title="申请时间：" :value="headInfo.crtTime"></hi-cell>
    <hi-cell title="供应商：" :value="headInfo.suppName"></hi-cell>
    <hi-cell title="合同类型：" :value="headInfo.contractTypeCode" :options="contractTypeList"></hi-cell>
    <hi-cell title="合同变更类型：" :value="headInfo.contractModifyMode" :options="poTypeOptions"></hi-cell>
    <hi-cell title="合同变更说明：" :value="headInfo.remark"></hi-cell>
  </div>
</template>

<script>
export default {
  name: 'BaseInfo',
  components: {},
  data() {
    return {}
  },
  props: {
    headInfo: {
      type: Object,
      default: () => ({})
    },
    contractTypeList: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    poTypeOptions() {
      return this.$store.getters.dicts.contract_modify_mode
    }
  }
}
</script>
